import React, { Component } from "react";
import PropTypes from "prop-types";
import Yup from "yup";
import { Form, Formik } from "formik";
import get from "lodash/get";
import has from "lodash/has";
import { withStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import axios from "axios";
import {
  MenuItem,
  Select,
  TextField,
  Typography,
  FormHelperText,
  FormControl,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import EnhancedCard from "common/components/EnhancedCard";
import SimpleSnackbar from "common/components/SimpleSnackbar";
import find from "lodash/find";
import { FORM_SUBMISSION_ERROR } from "common/constants";
import SubmitButton from "common/components/SubmitButton";
import resourceFactory from "common/admin/resourceFactory";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  icon: Yup.string().required("Icon name is required"),
  type: Yup.string().required("Type is required."),
  action: Yup.string().required("Type is required."),
  priority: Yup.number().required("Priority is required."),
});

class NotificationForm extends Component {
  state = {
    showFloorsField: false,
    html_content: this.props.initialValues.html_content,
  };
  generateImageUrl = (file, setFieldValue) => {
    const action = resourceFactory("gcp_services/generateSignedUrl");
    action.create({ fileName: file.name }).then((data) => {
      axios({
        url: data.url,
        method: "PUT",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        data: file,
      }).then(() => {
        setFieldValue("image", data.publicUrl);
        this.setState({ image: data.publicUrl });
      });
    });
  };
  displayFloorLabelById(id, floors) {
    const floor = find(floors, ["id", id]);
    return `Level ${floor.level}`;
  }
  componentDidMount() {
    if (this.props.initialValues.target === "floor") {
      this.setState({ showFloorsField: true });
    }
  }

  render() {
    const {
      classes,
      handleSubmit,
      initialValues,
      isEdit,
      isPublished,
      deleteNotification,
    } = this.props;

    return (
      <Formik
        enableReinitialize
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          isSubmitting,
          handleChange,
          status,
          setValues,
          setFieldValue,
        }) => (
          <Form>
            <Grid container direction="column" spacing={0}>
              <Grid size={{ xs: 12 }}>
                <Grid container direction="row">
                  <Grid size={{ xs: 6 }}>
                    <Typography variant="h5">
                      {isEdit ? "Edit Quick Links" : "Create Quick Links"}
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 6 }} className={classes.alignRight}>
                    {isPublished ? (
                      <Typography variant="body1">● Published</Typography>
                    ) : null}
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ xs: 12 }}>
                <EnhancedCard title="What is your Quick Link about?">
                  <Grid container direction="column">
                    <Grid className={classes.formGroup} size={{ xs: 6 }}>
                      <FormControl className={classes.formControl}>
                        <TextField
                          error={touched.name && has(errors, "name")}
                          id="name"
                          type="name"
                          name="name"
                          label="Name"
                          value={values.name}
                          onChange={handleChange}
                          helperText={touched.name && get(errors, "name")}
                        />
                      </FormControl>
                      <FormControl className={classes.formControl}>
                        <TextField
                          error={touched.icon && has(errors, "icon")}
                          id="icon"
                          type="name"
                          name="icon"
                          label="Icon"
                          value={values.icon}
                          onChange={handleChange}
                          helperText={touched.icon && get(errors, "icon")}
                        />
                      </FormControl>
                      <FormControl
                        className={classes.formControl}
                        disabled={isPublished}
                        error={touched.type && has(errors, "type")}
                      >
                        <Select
                          name="type"
                          id="type"
                          defaultValue={initialValues.type}
                          value={values.type || initialValues.type}
                          onChange={(event) => {
                            this.setState({
                              showFloorsField: event.target.value === "floor",
                            });
                            setFieldValue("type", event.target.value);
                          }}
                        >
                          <MenuItem value="routelink" key="routelink">
                            Route link
                          </MenuItem>
                          <MenuItem value="browser" key="browser">
                            Browser
                          </MenuItem>
                        </Select>
                        {touched.type && has(errors, "type") ? (
                          <FormHelperText>{get(errors, "type")}</FormHelperText>
                        ) : (
                          <FormHelperText>Type</FormHelperText>
                        )}
                      </FormControl>
                      <FormControl className={classes.formControl}>
                        <TextField
                          error={touched.action && has(errors, "action")}
                          id="action"
                          type="name"
                          name="action"
                          label="Action"
                          value={values.action}
                          onChange={handleChange}
                          helperText={touched.action && get(errors, "action")}
                        />
                      </FormControl>
                      <FormControl className={classes.formControl}>
                        <TextField
                          error={touched.priority && has(errors, "priority")}
                          id="priority"
                          type="number"
                          name="priority"
                          label="Priority"
                          value={values.priority}
                          onChange={handleChange}
                          helperText={
                            touched.priority && get(errors, "priority")
                          }
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </EnhancedCard>
              </Grid>
              <Grid size={{ xs: 12 }}>
                <Grid container direction="row">
                  <Grid size={{ xs: 6 }}>
                    <SubmitButton isSubmitting={isSubmitting}>
                      {isEdit ? "Update Quick Link" : "Create Quick Link"}
                    </SubmitButton>
                  </Grid>
                  <Grid size={{ xs: 6 }} className={classes.alignRight}>
                    {isEdit ? (
                      <Button
                        variant="contained"
                        color="secondary"
                        className={classes.buttonDelete}
                        onClick={() => {
                          deleteNotification();
                        }}
                      >
                        Delete
                      </Button>
                    ) : null}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {get(status, "success") ? (
              <SimpleSnackbar
                message={
                  isEdit
                    ? "Quick Link updated!"
                    : "New quick link successfully created!"
                }
              />
            ) : null}
            {has(errors, "http") ? (
              <SimpleSnackbar message={FORM_SUBMISSION_ERROR} />
            ) : null}
          </Form>
        )}
      </Formik>
    );
  }
}

const styles = (theme) => ({
  button: {
    marginTop: theme.spacing(2),
  },
  buttonDelete: {
    marginTop: theme.spacing(1),
  },
  formControl: {
    margin: theme.spacing(1),
    width: "100%",
  },
  disabled: {
    opacity: 0.6,
  },
  alignRight: {
    textAlign: "right",
  },
});

NotificationForm.propTypes = {
  classes: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
  floors: PropTypes.array,
  timezone: PropTypes.string.isRequired,
  isEdit: PropTypes.bool,
  deleteNotification: PropTypes.func,
};

export default withStyles(styles)(NotificationForm);
